import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { getUserOrderDetails } from "../../services/api";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useToast } from "../../context/ToastContext";
import * as PR from "../../prime-modules/index";

const B2BPaymentRes = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { labels } = useToast();
  const { pathname, state } = useLocation();
  const params = useParams();

  const downloadQRCode = (qrcode) => {
    const downloadLink = document.createElement("a");
    downloadLink.href = qrcode;
    downloadLink.download = "QR_Code.png";
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
  };

  useEffect(() => {
    if (window?.webviewData?.sessionId && params?.orderId) {
      const getB2bPaymentResponseHandler = () => {
        const getResponse = (response) => {
          window.ReactNativeWebView.postMessage(
            JSON.stringify({
              response,
            })
          );
          if (response?.result === "SUCCESS") {
            navigate(pathname, {
              replace: true,
              state: { paymentResponse: response?.data },
            });
          } else {
            //   setJwtStatus("Failed to get the payment details");
            //   const error = response.error;
            //   showToast(error.severity, error.errorMsg);
          }
        };

        const request = {
          orderId: params?.orderId,
        };
        const headers = { sessionid: window?.webviewData?.sessionId };
        getUserOrderDetails(request, headers, dispatch, getResponse);
      };

      getB2bPaymentResponseHandler();
    } else {
      navigate("/")
    }
  }, [dispatch, navigate, params?.orderId, pathname]);

  return (
    <div className="p-4 payment-res">
      {state?.paymentResponse?.qrCodeImage ? (
        <>
          <h2>Payment Successful</h2>
          <p> Thank you. Your order has been received. </p>
          <p>
            You can scan this QR code right away from the target phone to
            activate your bundle
          </p>
          <img
            src={`data:image/png;base64,${state?.paymentResponse?.qrCodeImage}`}
            id="qrCodeEl"
            alt="qrcode"
            className="qr-code"
          />
        </>
      ) : (
        <p>
          We have received your payment. You’ll receive an email with the order
          details shortly. You can also view your eSIMs in the My Account
          section.
        </p>
      )}
      {state?.paymentResponse?.qrCodeImage && (
        <PR.Button
          type="button"
          label={labels.LBL0056}
          value={labels.LBL0056}
          className="download-button"
          onClick={() =>
            downloadQRCode(
              `data:image/png;base64,${state?.paymentResponse?.qrCodeImage}`
            )
          }
        />
      )}
      {state?.paymentResponse?.email && (
        <span className="scan-text mt-3">
          {labels.LBL0055}{" "}
          <span className="payer-email"> {state?.paymentResponse?.email}</span>{" "}
        </span>
      )}
    </div>
  );
};

export default B2BPaymentRes;
